<template>
  <div ref="map" style="height: 100%; width: 100%">

  </div>
</template>

<script>
import gmapsInit from '@/model/gmaps'
import $ from 'cash-dom'

export default {
  props: ['latLng'],
  data () {
    return {
      markers: [{
        position: this.latLng
      }]
    }
  },
  methods: {
    pinSymbol (color) {
      return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: '#fff',
        strokeWeight: 2,
        scale: 1
      }
    },
    initialize (google) {
      const myStyles = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
]

      var myLatlng = new google.maps.LatLng(this.latLng)
      var mapCanvas = this.$refs.map

      var mapOptions = {
        center: myLatlng,
        zoom: 16,
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: myStyles
      }

      var map = new google.maps.Map(mapCanvas, mapOptions)

      var mapPanX = 130

      // @todo: tohle bude nutno upravit az se dostaneme pod viewoport <RJ, 03.04.2017 15:44:02>
      map.panBy(mapPanX, 0)

      var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        icon: this.pinSymbol('#ee6e55')
      })

      var infowindow = new google.maps.InfoWindow({
        content: $('#gMap-bubble-content').html(),
        pixelOffset: new google.maps.Size(-215, -10)
      })

      google.maps.event.addListener(infowindow, 'domready', function () {
        var iwOuter = $('.gm-style-iw')
        var iwBackground = iwOuter.prev()

        iwBackground.children(':nth-child(2)').css({ display: 'none' })
        iwBackground.children(':nth-child(4)').css({ display: 'none' })
        iwBackground.children(':nth-child(3)').css({ display: 'none' })
        var iwCloseBtn = iwOuter.next()
        iwCloseBtn.hide()

        iwOuter.find('.gm-style-iw-d').css(
          {
            overflow: 'hidden'
          }
        )

        iwOuter.find('button').hide()
      })

      marker.addListener('click', function () {
        infowindow.open(map, marker)
      })

      // jinak okno s bublinou skace, protoze se uz nejedna o nativni okno ale prestylovane <RJ, 03.04.2017 14:33:36>
      google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
        infowindow.open(map, marker)
      })
    }
  },
  async mounted () {
    const google = await gmapsInit()

    //google.maps.event.addDomListener(window, 'load', () => {
    this.$nextTick(() => {
      this.initialize(google)
    })
  },
  async updated () {
    const google = await gmapsInit()

    //google.maps.event.addDomListener(window, 'load', () => {
    this.$nextTick(() => {
      this.initialize(google)
    })
  }
}
</script>
